import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from "../";
import { IBaseResponse, IDonorProfileMedicalDetailsData, IDonorProfileMedicalDetailsLookupData } from '@nkr/models/index';
import { IDonorProfileMedicalDetailsPost } from '@nkr/models/donor-profile/medical-details';

export interface IDonorProfileMedicalDetailsResponse {
    data: {
        success: boolean,
        results: IDonorProfileMedicalDetailsData
    }
}

export interface IDonorProfileMedicalDetailsLookupDataResponse {
    data: {
        success: boolean;
        results: IDonorProfileMedicalDetailsLookupData;
    }
}

export const ActionCreators = {
    getProfileMedicalDetailsData: (donorId: number, centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IDonorProfileMedicalDetailsResponse> => {
        let options = {
            url: `${__API__}/center/${centerId}/donor/${donorId}/medical-details`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    getProfileMedicalDetailsLookupData: (centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IDonorProfileMedicalDetailsLookupDataResponse> => {
        let options = {
            url: `${__API__}/center/${centerId}/donor/medical-details/lookup-data`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    postProfileMedicalDetailsData: (donorId: number, centerId: number, data: IDonorProfileMedicalDetailsPost) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/center/${centerId}/donor/${donorId}/medical-details`,
            data
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    
}